import { createGlobalState } from '@vueuse/core';

function useSingleton(createInstance = () => {
}) {
  return createGlobalState(createInstance);
}

export { useSingleton as u };
//# sourceMappingURL=useSingleton-D8gLr_EB.js.map
